import script from "./PedidoPaso2.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoPaso2.vue?vue&type=script&setup=true&lang=js"

import "./PedidoPaso2.vue?vue&type=style&index=0&id=138fba78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138fba78"]])

export default __exports__